import _ from "lodash"

export const getCommonTransactionData = state => _.get(state,['common','transactionData','data'],null)

//config
export const getConfigBrokerageOverRateValue = config => _.get(config,['brokerage_over_100k','value'],0.18)
export const getConfigBrokerageUnderRateValue = config => _.get(config,['brokerage_under_100k','value'],0.35)
export const getConfigClearingFeeValue = config => _.get(config,['clearing_fee','value'],0.03)
export const getConfigIntraDayRateValue = config => _.get(config,['intra_day_rate','value'],0.15)
export const getConfigMaxClearingFeeValue = config => _.get(config,['max_clearing_fee','value'],1000)
export const getConfigMaxStampDutyValue = config => _.get(config,['max_stamp_duty','value'],1000)
export const getConfigMaxStampDutyWarrantValue = config => _.get(config,['max_stamp_duty_warrant','value'],200)
export const getConfigMinBrokerageValue = config => _.get(config,['min_brokerage','value'],12)
export const getConfigMofValue = config => _.get(config,['mof','value'],60)
export const getConfigSSTValue = config => _.get(config,['sst','value'],0)
export const getConfigStampDutyValue = config => _.get(config,['stamp_duty','value'],0.1)
export const getConfigStampDutyWarrantValue = config => _.get(config,['stamp_duty_warrant','value'],0.1)

export const getMarginConfigStockMovement = config => _.get(config,['data','stock_movement'],[])
export const getMarginConfigBeforeMarginAmount = config => _.get(config,['data','before_summary','margin_amount','value'],0)
export const getMarginConfigBeforeMarginPosition = config => _.get(config,['data','before_summary','margin_position','value'],0)
export const getMarginConfigBeforeMarketValue = config => _.get(config,['data','before_summary','market_value','value'],0)
export const getMarginConfigBeforeOutstandingAmount = config => _.get(config,['data','before_summary','outstanding_amount','value'],0)
export const getMarginConfigBeforePercentum = config => _.get(config,['data','before_summary','percentum','value'],0)

//
export const getToolItemCapPrice = item => _.get(item,['cap_price','value'],0)
export const getToolItemMarginAmount = item => _.get(item,['margin_amount','value'],0)
export const getToolItemMarketValue = item => _.get(item,['market_value','value'],0)
export const getToolItemMof = item => _.get(item,['mof','value'],0)
export const getToolItemOutstandingAmount = item => _.get(item,['outstanding_amount','value'],0)
export const getToolItemPrice= item => _.get(item,['price','value'],0)
export const getToolItemQuantity= item => _.get(item,['quantity'],0)
export const getToolItemQIsExisting= item => _.get(item,['is_existing'],false)
export const getToolItemStockCode= item => _.get(item,['stock_code'],'')
export const getToolItemStockName= item => _.get(item,['stock_name'],'')
